import { useAtom, useSetAtom } from 'jotai'
import { useDispatch } from 'react-redux'
import { orderInvoicePanel } from 'src/atoms/modals/orderInvoicePanel.atom'
import { orderManagerModal } from 'src/atoms/modals/orderManagerModal.atom'
import { orderTimelineModal } from 'src/atoms/modals/orderTimelineModal.atom'
import { calendarSelectorPopover } from 'src/atoms/modals/calendarSelectorPopover'
import {
  OverlayAction,
  OverlayResource
} from 'src/componentsV2/CoreUX/actions/overlayAction/overlayAction.types'
import { toggleSchedulePanel } from 'src/redux-api-bridge/schedule/effects'
import { openTrackDeliveryPanel } from 'src/redux/slices/trackDeliveryPanel/slice'
import { useCart } from './useCart'
import { useSkipOrderDeflection } from './useSkipOrderDeflection'
import { useUnskip } from './useUnskip'
import { orderHubCart } from 'src/atoms/modals/orderHubCart.atom'

interface UseOverlayManagerReturn {
  showOverlay: (action: OverlayAction) => void
}

export const useOverlayManager = (): UseOverlayManagerReturn => {
  const dispatch = useDispatch()
  const setIsOpenCalendarSelector = useSetAtom(calendarSelectorPopover)
  const setOrderHubCart = useSetAtom(orderHubCart)
  const [{ date: orderManagerDate }, setIsOpenOrderManager] = useAtom(
    orderManagerModal
  )
  const setIsOpenOrderTimeline = useSetAtom(orderTimelineModal)
  const setIsOpenOrderInvoice = useSetAtom(orderInvoicePanel)
  const { setIsCartOpen } = useCart()
  const { handleOnSkip } = useSkipOrderDeflection({ date: orderManagerDate })
  const { unskipIfRequired } = useUnskip(orderManagerDate, {
    page_name: 'Orders - Manage your order'
  })

  const showOverlay = (action: OverlayAction): void => {
    switch (action.data.resource) {
      case OverlayResource.HomeCalendarSelector:
        setIsOpenCalendarSelector({
          isOpen: true,
          date: action.data.parameters?.date
        })
        break
      case OverlayResource.AddExtraDeliveryDay:
        dispatch(
          toggleSchedulePanel(
            'extraDelivery',
            true,
            action.data.parameters?.date
          )
        )
        break
      case OverlayResource.OrderManagement:
        setIsOpenOrderManager({
          isOpen: true,
          date: action.data.parameters?.date
        })
        break
      case OverlayResource.OrderInvoice:
        setIsOpenOrderInvoice({
          isOpen: true,
          date: action.data.parameters?.date
        })
        break
      case OverlayResource.OrderTimeline:
        setIsOpenOrderTimeline({
          isOpen: true,
          date: action.data.parameters?.date
        })
        break
      case OverlayResource.RescheduleOrder:
        setIsOpenOrderManager({
          isOpen: false,
          date: action.data.parameters?.date
        })
        dispatch(
          toggleSchedulePanel('reschedule', true, action.data.parameters?.date)
        )
        break
      case OverlayResource.OrderTracking:
        dispatch(openTrackDeliveryPanel(action.data.parameters?.type))
        break
      case OverlayResource.CartDetail:
        setOrderHubCart({ date: action.data.parameters?.date })
        setIsCartOpen(true)
        break
      case OverlayResource.OrderSkip:
        setIsOpenOrderManager({
          isOpen: false,
          date: action.data.parameters?.date
        })
        handleOnSkip()
        break
      case OverlayResource.OrderUnskip:
        setIsOpenOrderManager({
          isOpen: false,
          date: action.data.parameters?.date
        })
        unskipIfRequired()
        break
    }
  }

  return { showOverlay }
}
